import { UsageFeatureProps } from '@employee-experience/common';
import { ILetterTemplate } from '../../models/ILetterTemplate';
import {
  IReceiveTemplatesAction,
  IReceiveTemplatesFailedAction,
  IRequestTemplatesAction,
  TemplateActionTypes,
} from '../action-types/templateActionTypes';

export function requesteTemplates(
  feature: UsageFeatureProps,
  impersonatedCompanyCode: string,
  impersonatedCostCenter: string
): IRequestTemplatesAction {
  return {
    type: TemplateActionTypes.REQUEST_TEMPLATES,
    feature,
    impersonatedCompanyCode,
    impersonatedCostCenter,
  };
}

export function receiveTemplates(templates: ILetterTemplate[]): IReceiveTemplatesAction {
  return {
    type: TemplateActionTypes.RECEIVE_TEMPLATES,
    templates,
  };
}

export function receiveTemplatesFailed(
  errorMessage: string,
  statusCode: number
): IReceiveTemplatesFailedAction {
  return {
    type: TemplateActionTypes.REQUEST_TEMPLATES_FAILED,
    errorMessage,
    statusCode,
  };
}
